import React from 'react';

interface SpinnerProps {
  size?: number;
  className?: string;
}

export default function Spinner({ size = 16, className = '' }: SpinnerProps) {
  return (
    <div
      className={`animate-spin rounded-full border-2 border-gray-300 border-t-primary ${className}`}
      style={{ width: size, height: size }}
    />
  );
}